import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-42",
  "use": "icon-icon-nav-42-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-42\"><path d=\"M192 815.168h640v-101.12H192v101.12z m606.336-437.888H225.664A33.792 33.792 0 0 0 192 410.88V613.12c0 18.56 15.168 33.664 33.664 33.664h572.672c18.56 0 33.664-15.168 33.664-33.664V410.88a33.792 33.792 0 0 0-33.664-33.664zM192 208.832v101.12h640v-101.12H192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-42.svg
// module id = IUXe
// module chunks = 3